<template>
    <div class="container">
        <div class="spinner-wrapper">
            <div class="text-center">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <!-- Loading {{title}}, Give us a second... -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'content-loader',

    props: {
        title: {
            type: String,
            default: 'Title',
        },
    }
}
</script>

<style scoped>
    .spinner-wrapper {
        text-align: center;
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .spinner-border {
        border: 0.25em solid #000112;
        border-right-color: transparent;
    }
</style>
